import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { ImovelFocus } from "../../ImovelFocus";
import { ImovelFocusRural } from "../../ImovelFocusRural";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
interface Props {
  guiaFocus: any;
  onClose: () => void;
}
export function Panel({ guiaFocus, onClose }: Props) {
  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={guiaFocus.ID ? true : false}
        onClose={onClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onClose}
              aria-label="close"
            >
              {/* <CloseIcon /> */}
            </IconButton>
            <Typography
              sx={{ ml: 2, flex: 1 }}
              variant="h6"
              component="div"
            ></Typography>
            <Button autoFocus color="inherit" onClick={onClose}>
              <CloseIcon />
            </Button>
          </Toolbar>
        </AppBar>
        
        {guiaFocus.ISRURAL==1 ? (
           <ImovelFocusRural
             id_props={guiaFocus.ID}
             id_pesquisa={guiaFocus.PREFEITURA_ID}
           />
         
        ) : (
          <ImovelFocus
            id_props={guiaFocus.ID}
            id_pesquisa={guiaFocus.PREFEITURA_ID}
          />
        )}
      </Dialog>
    </React.Fragment>
  );
}
